module.exports = __webpack_public_path__ + "static/media/productLabeling3.77afdcd6.jpg";